'use client';
import '../../public/fonts/webfonts/font-face.css';
import '../index.css';
import 'react-toastify/dist/ReactToastify.min.css';
import { type PropsWithChildren, Suspense } from 'react';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { Slide, ToastContainer } from 'react-toastify';
import RollbarProvider from '@/providers/RollbarProvider';
import AppProviders from '@/providers/AppProviders';
import LoadingApp from '@/components/LoadingApp';
import { theme } from '@/utils/theme';
import { classes } from './utils';

export default function Layout({ children }: PropsWithChildren) {
  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#0e1c1e" />
        <meta name="description" content="Pulse Dashboard" />
        <title>Pulse | Angel Clinicians</title>
        {/* FAVICON */}
        <link
          rel="icon"
          type="image/png"
          sizes="96x96"
          href="/favicon/favicon-96x96.png"
        />
        <link rel="icon" type="image/svg+xml" href="/favicon/favicon.svg" />
        <link rel="shortcut icon" href="/favicon/favicon.ico" />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/favicon/apple-touch-icon.png"
        />
        <meta name="apple-mobile-web-app-title" content="Pulse" />
        <link rel="manifest" href="/favicon/site.webmanifest" />
        {/* END FAVICON */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
      </head>
      <body>
        <RollbarProvider>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
              <Suspense fallback={<LoadingApp />}>
                <AppProviders>
                  <div className={classes.app}>
                    <ToastContainer
                      hideProgressBar
                      closeOnClick
                      newestOnTop
                      pauseOnFocusLoss
                      pauseOnHover
                      rtl={false}
                      draggable={false}
                      theme="light"
                      position="bottom-right"
                      autoClose={3000}
                      transition={Slide}
                    />
                    {children}
                  </div>
                </AppProviders>
              </Suspense>
            </ThemeProvider>
          </StyledEngineProvider>
        </RollbarProvider>
      </body>
    </html>
  );
}
